<template>
	<div id="home">
		<div>
			<div>
				<!-- todo... -->
				<div class="left-top" style="background: #4278D2;width: 100%; overflow: hidden;">
					<!-- <div class="item" v-for="todo in todoLists" :key='todo.id' @click="linkPage(todo.url)">
						<span>{{todo.data}}</span>
						<p>{{todo.name}}</p>
					</div> -->
					<!-- <section style="overflow: hidden;width: 100%;height: 10px; background:red; "></section> -->
					<section class="icon-swiper-container" style="width: 900px">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="item in iconList" :key="item" @click="jumpToPage(item.url)">
								<section class="swiper-slide-content">
									<div class="slide-img">
										<img :src="item.img" alt="">
									</div>
									<p class="slide-f">{{item.label}}</p>
								</section>
							</div>
						</div>
					</section>
				</div>
			</div>
			<div>
				<h2Title title="工作日历" style="margin-top: 10px;"></h2Title>
				<calendar :showMask.sync="showMask">
				</calendar>
			</div>
		</div>
		<div>
			<div class="leftCon" style="height: 100%">
				<cwRight></cwRight>	
				<!-- <h2Title title="人事概况"></h2Title>
				<charts></charts>

				<quickAccess :showMask.sync="showMask"></quickAccess>
				<h2Title title="资讯" style="margin-top: 10px;">
					<el-link type="info" class="shortMenu" @click="more()">
						查看更多</el-link>
				</h2Title>
				<informationList></informationList>
				<div class="img"><img src="@/assets/img/main/bg1.png" @click="openPage()" style="width: 100%;" alt=""></div> -->
			</div>
		</div>
		<div class="Mask" v-if="showMask"></div>
	</div>
</template>

<script>
	import { queryPendingList,queryPendingNum,queryOperManual } from "@/api/msg/msg";

	import h2Title from "@/page/statistics2/template/title.vue";
	import charts from "@/page/statistics2/template/charts.vue";
	import quickAccess from "@/page/statistics2/template/quick-access.vue";
	import informationList from "@/page/statistics2/template/information-list.vue";
	import calendar from "@/page/statistics2/template/calendar.vue";
	import cwRight from "@/page/statistics2/template/right/right.vue";

	export default {
		name: "index",
		data() {
			return {
				todoLists:[],
				showMask:false,
				iconList: [
					{ img: require('@/assets/webImg/admin/workbench_icon1.svg'), url: '/per/perEntryPage.action', label: '入职管理' },
					{ img: require('@/assets/webImg/admin/workbench_icon2.svg'), url: '/atndset/toindex.action', label: '考勤设置' },
					{ img: require('@/assets/webImg/admin/workbench_icon3.svg'), url: '/approval/toindex.action', label: '审批设置' },
					{ img: require('@/assets/webImg/admin/workbench_icon4.svg'), url: '/vacnstandard/toindex.action', label: '休假设置' },
					{ img: require('@/assets/webImg/admin/workbench_icon5.svg'), url: '/wage/salarySet', label: '薪酬设置' },
					{ img: require('@/assets/webImg/admin/workbench_icon6.svg'), url: '/wage/data-ready-template', label: '数据准备' },
					{ img: require('@/assets/webImg/admin/workbench_icon7.svg'), url: '/wage/salaryTax', label: '个税申报' },
					{ img: require('@/assets/webImg/admin/workbench_icon8.svg'), url: '/wage/salaryApproval', label: '薪酬审批' },
					{ img: require('@/assets/webImg/admin/workbench_icon9.svg'), url: '/per/toPerList.action?sysFunctionCode=OTA4NDAwMTY-', label: '员工管理' },
					{ img: require('@/assets/webImg/admin/workbench_icon10.svg'), url: '/wage/paymentWage', label: '薪酬发放' },
					{ img: require('@/assets/webImg/admin/workbench_icon11.svg'), url: '/wage/wageHistory', label: '薪酬历史' },
				]
			}
		},
		created() {
			// debugger;

      var ruZhi = JSON.parse(sessionStorage.getItem("ruZhi"));
      var yuanGong = JSON.parse(sessionStorage.getItem("yuanGong"));
      var heTong = JSON.parse(sessionStorage.getItem("heTong"));
      var xinZi = JSON.parse(sessionStorage.getItem("xinZi"));
        queryPendingList().then(res =>{
          let todoLists = res.data.data;
          if(todoLists!=null&&todoLists.length>0){
            for(let i=0;i<todoLists.length;i++){
              todoLists[i].data=0;
            }
          }
          if(ruZhi != "入职管理"){
            todoLists[0].url="#"
          }
          if(yuanGong != "员工管理"){
            todoLists[1].url="#"
          }
          if(heTong != "合同管理"){
            todoLists[2].url="#"
          }
          if(xinZi != "薪资待完成"){
            todoLists[3].url="#"
          }
          if(yuanGong != "员工管理"){
            todoLists[4].url="#"
          }
          this.todoLists = todoLists;
          //遍历请求数量
          for(let i=0;i<this.todoLists.length;i++){
            this.queryPendingNum(i);//加载数量
          }
        })
		},
		components: {
			h2Title,
			charts,
			quickAccess,
			informationList,
			calendar,
			cwRight
		},

		mounted() {
			var swiper2 = new Swiper('.icon-swiper-container', {
				slidesPerView: 6,
				// loop: true,
				// centeredSlides: true,
				spaceBetween : 10,
				// grabCursor: true,       // 小手
			});
		},
		methods: {
			//加载待办数量
			queryPendingNum(i){
				queryPendingNum(this.todoLists[i].funcSign).then(res=>{
					this.todoLists[i].data = res.data.data;
				})
			},

			linkPage(url){
				this.$router.push({path:url});
			},

			more(){
				this.$router.push({path:'/information'});
			},

			openPage(){
				let guide = this.$router.resolve({
					   path: "/guide"
					});
				window.open(guide.href, '_blank');
			},

			jumpToPage(url) {
				this.$router.push({path: url});
			}
		}
	};
</script>
<style scoped="scoped" lang="scss">
	#main #home {
		background: transparent;
		box-shadow: none;
		padding: 0;
		padding-top: 20px;
		display: flex;
	}

	#home>div:nth-of-type(1) {
		flex-grow: 1;
		margin-right: 20px;
	}

	.leftCon {
		width: 400px;
	}

	.left-top {
		display: flex;
		background: #fff;
		height: 174px;
		box-shadow: 0px 2px 4px 0px rgba(208,216,255,0.15);
		border-radius: 9px;
		align-items: center;
		justify-content: space-between;
	}
		@media screen and (min-width: 1920px) {
			.left-top {
				height: 140px;
				}
		}

	.left-top .item {
		flex-grow: 1;
		position: relative;
		cursor: pointer;
	}

	.left-top .item:after {
		content: '';
		position: absolute;
		right: 0;
		top: 8px;
		width: 2px;
		height: 68px;
		background: rgba(234, 234, 234, 1);
	}

	.left-top .item:nth-last-of-type(1):after {
		display: none;
	}

	.left-top span {
		display: block;
		font-size: 56px;
		line-height: 56px;
		font-weight: 400;
		color: rgba(255, 134, 121, 1);
		text-align: center;
	}

	.left-top .item:nth-of-type(2) span {
		color: #27CCC3;
	}

	.left-top .item:nth-of-type(3) span {
		color: #44D38A;
	}

	.left-top .item:nth-of-type(4) span {
		color: #F06565;
	}

	.left-top .item:nth-of-type(5) span {
		color: #678FE6;
	}

	.left-top .item:nth-of-type(6) span {
		color: #E785BC;
	}

	.left-top p {
		font-size: 20px;
		font-weight: 500;
		color: rgba(153, 153, 153, 1);
		line-height: 20px;
		text-align: center;
		margin-top: 10px;
	}

	.img img {
		margin-top: 10px;
		display: block;
		cursor: pointer;
	}

	.el-link.is-underline:hover:after{
		display: none;
	}
	.shortMenu>>>.el-link--inner {
		font-size: 13px;
		color: rgba(153, 153, 153, 1);
	}
	.Mask{
		position: fixed;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		background:rgba(0,0,0,.2);
		z-index: 8;
	}


	/** 头部图标 */
	.left-top .icon-swiper-container .swiper-wrapper {
		.swiper-slide-content {
			width: 160px;
			height: 134px;
			padding-top: 40px;
			.slide-img {
                height: 52px;
                width: 100%;
                text-align: center;
                img {
					display: inline-block;
                    height: 100%;
                }
            }

			.slide-f {
				margin-top: 20px;
				width: 100%;
                font-size: 16px;
                font-weight: 500;
                color: #ffffff;
				text-align: center;
            }
		}
	}
</style>
